/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_List_Filter_All_ProductsInputs */

const vi_product_lot_list_filter_all_products = /** @type {(inputs: Product_Lot_List_Filter_All_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả sản phẩm`)
};

/**

* @param {Product_Lot_List_Filter_All_ProductsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_list_filter_all_products = /** @type {((inputs?: Product_Lot_List_Filter_All_ProductsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_List_Filter_All_ProductsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_list_filter_all_products(inputs)
});